/**
 * The schema's limits, the same on every plan (the server's `schema::MAX_ENTITIES` / `MAX_FIELDS`: a guard against
 * runaway scripts, not a pricing lever). The app stops offering "New entity" / "Add field" at them.
 */
export const MAX_ENTITIES = 100;
export const MAX_FIELDS = 200;
